/**
 * @generated SignedSource<<4e12cce9874eb14ecf1635f2a87251ee>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type UserFieldVisibilitySettingEnumType = "Admin" | "AdminManager" | "AdminManagerEmployee" | "Everyone";
export type DirectoryProfileQuery$variables = {
  userEntityId: string;
};
export type DirectoryProfileQueryVariables = DirectoryProfileQuery$variables;
export type DirectoryProfileQuery$data = {
  readonly viewer: {
    readonly features: any | null;
    readonly user: {
      readonly viewerIsUser: boolean;
      readonly startedAfterPercentage: number | null;
      readonly entityId: string;
      readonly name: string | null;
      readonly title: string | null;
      readonly avatarUrl: string | null;
      readonly startDate: DateString | null;
      readonly phoneNumber: string | null;
      readonly timezone: string | null;
      readonly realTimezone: string | null;
      readonly email: string | null;
      readonly department: {
        readonly name: string | null;
        readonly entityId: string;
      } | null;
      readonly manager: {
        readonly entityId: string;
        readonly name: string | null;
        readonly email: string | null;
      } | null;
      readonly products: {
        readonly feedback: {
          readonly isEnabled: boolean;
        };
      };
      readonly viewerVisibleCustomProfileFields: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly __typename: string;
            readonly fieldName: string;
            readonly displayedValue: string | null;
            readonly privacyLevel: UserFieldVisibilitySettingEnumType;
            readonly choiceUser?: {
              readonly entityId: string;
              readonly email: string | null;
              readonly name: string | null;
            } | null;
          } | null;
        } | null> | null;
      } | null;
      readonly viewerUserRelationship: {
        readonly isOneOnOneActive: boolean;
        readonly oneOnOneMeetings: {
          readonly edges: ReadonlyArray<{
            readonly node: {
              readonly scheduledAt: DateString;
              readonly entityId: string;
            } | null;
          } | null> | null;
        } | null;
        readonly nextRecurringOneOnOneMeeting: {
          readonly id: string;
          readonly scheduledAt: DateString;
          readonly entityId?: string;
        } | null;
        readonly report: {
          readonly entityId: string;
          readonly viewerIsUser: boolean;
          readonly " $fragmentSpreads": FragmentRefs<"NextMeetingCard_user">;
        } | null;
        readonly manager: {
          readonly entityId: string;
          readonly viewerIsUser: boolean;
          readonly " $fragmentSpreads": FragmentRefs<"NextMeetingCard_user">;
        } | null;
      } | null;
      readonly viewerVisibleFeedback: {
        readonly pageInfo: {
          readonly hasNextPage: boolean;
        };
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly id: string;
            readonly " $fragmentSpreads": FragmentRefs<"FeedbackCard_feedback">;
          } | null;
        } | null> | null;
      } | null;
      readonly activeGoals: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly " $fragmentSpreads": FragmentRefs<"GoalCard_goal">;
          };
        } | null> | null;
      } | null;
    } | null;
  } | null;
};
export type DirectoryProfileQueryResponse = DirectoryProfileQuery$data;
export type DirectoryProfileQuery = {
  variables: DirectoryProfileQueryVariables;
  response: DirectoryProfileQuery$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "userEntityId"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "features",
  "storageKey": null
},
v2 = [
  {
    "kind": "Variable",
    "name": "userId",
    "variableName": "userEntityId"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "viewerIsUser",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "startedAfterPercentage",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "entityId",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "avatarUrl",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "startDate",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "phoneNumber",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "timezone",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "realTimezone",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "concreteType": "UserProducts",
  "kind": "LinkedField",
  "name": "products",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "UserProductSettings",
      "kind": "LinkedField",
      "name": "feedback",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isEnabled",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v15 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 30
  }
],
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fieldName",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayedValue",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "privacyLevel",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isOneOnOneActive",
  "storageKey": null
},
v21 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 1
  }
],
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "scheduledAt",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v24 = {
  "kind": "InlineFragment",
  "selections": [
    (v5/*: any*/)
  ],
  "type": "OneOnOneMeeting",
  "abstractKey": null
},
v25 = [
  (v5/*: any*/),
  (v3/*: any*/),
  {
    "args": null,
    "kind": "FragmentSpread",
    "name": "NextMeetingCard_user"
  }
],
v26 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 20
  }
],
v27 = {
  "alias": null,
  "args": null,
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasNextPage",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v28 = [
  {
    "kind": "Literal",
    "name": "last",
    "value": 100
  },
  {
    "kind": "Literal",
    "name": "orderBy",
    "value": "Priority"
  },
  {
    "kind": "Literal",
    "name": "state",
    "value": "ACTIVE"
  }
],
v29 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "preferredName",
  "storageKey": null
},
v30 = [
  (v5/*: any*/),
  (v3/*: any*/),
  (v23/*: any*/),
  (v29/*: any*/),
  (v6/*: any*/),
  (v8/*: any*/)
],
v31 = [
  (v6/*: any*/),
  (v23/*: any*/)
],
v32 = [
  (v23/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DirectoryProfileQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": "user",
            "args": (v2/*: any*/),
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "findUser",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              (v12/*: any*/),
              (v13/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Department",
                "kind": "LinkedField",
                "name": "department",
                "plural": false,
                "selections": [
                  (v6/*: any*/),
                  (v5/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "manager",
                "plural": false,
                "selections": [
                  (v5/*: any*/),
                  (v6/*: any*/),
                  (v13/*: any*/)
                ],
                "storageKey": null
              },
              (v14/*: any*/),
              {
                "alias": null,
                "args": (v15/*: any*/),
                "concreteType": "viewerVisibleCustomProfileFieldsConnection",
                "kind": "LinkedField",
                "name": "viewerVisibleCustomProfileFields",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "viewerVisibleCustomProfileFieldsEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v16/*: any*/),
                          (v17/*: any*/),
                          (v18/*: any*/),
                          (v19/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "User",
                                "kind": "LinkedField",
                                "name": "choiceUser",
                                "plural": false,
                                "selections": [
                                  (v5/*: any*/),
                                  (v13/*: any*/),
                                  (v6/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "type": "RelationshipCustomProfileField",
                            "abstractKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "viewerVisibleCustomProfileFields(first:30)"
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "CheckinRelationship",
                "kind": "LinkedField",
                "name": "viewerUserRelationship",
                "plural": false,
                "selections": [
                  (v20/*: any*/),
                  {
                    "alias": null,
                    "args": (v21/*: any*/),
                    "concreteType": "checkinRelationshipOneOnOneMeetingsConnection",
                    "kind": "LinkedField",
                    "name": "oneOnOneMeetings",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "checkinRelationshipOneOnOneMeetingsEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "OneOnOneMeeting",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v22/*: any*/),
                              (v5/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": "oneOnOneMeetings(first:1)"
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "nextRecurringOneOnOneMeeting",
                    "plural": false,
                    "selections": [
                      (v23/*: any*/),
                      (v22/*: any*/),
                      (v24/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "User",
                    "kind": "LinkedField",
                    "name": "report",
                    "plural": false,
                    "selections": (v25/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "User",
                    "kind": "LinkedField",
                    "name": "manager",
                    "plural": false,
                    "selections": (v25/*: any*/),
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v26/*: any*/),
                "concreteType": "UserVisibleFeedbackConnection",
                "kind": "LinkedField",
                "name": "viewerVisibleFeedback",
                "plural": false,
                "selections": [
                  (v27/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "UserVisibleFeedbackEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v23/*: any*/),
                          {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "FeedbackCard_feedback"
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "viewerVisibleFeedback(first:20)"
              },
              {
                "alias": "activeGoals",
                "args": (v28/*: any*/),
                "concreteType": "userOwnedGoalsConnection",
                "kind": "LinkedField",
                "name": "ownedGoals",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "userOwnedGoalsEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Goal",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "GoalCard_goal"
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "ownedGoals(last:100,orderBy:\"Priority\",state:\"ACTIVE\")"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DirectoryProfileQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": "user",
            "args": (v2/*: any*/),
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "findUser",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              (v12/*: any*/),
              (v13/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Department",
                "kind": "LinkedField",
                "name": "department",
                "plural": false,
                "selections": [
                  (v6/*: any*/),
                  (v5/*: any*/),
                  (v23/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "manager",
                "plural": false,
                "selections": [
                  (v5/*: any*/),
                  (v6/*: any*/),
                  (v13/*: any*/),
                  (v23/*: any*/)
                ],
                "storageKey": null
              },
              (v14/*: any*/),
              {
                "alias": null,
                "args": (v15/*: any*/),
                "concreteType": "viewerVisibleCustomProfileFieldsConnection",
                "kind": "LinkedField",
                "name": "viewerVisibleCustomProfileFields",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "viewerVisibleCustomProfileFieldsEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v16/*: any*/),
                          (v17/*: any*/),
                          (v18/*: any*/),
                          (v19/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "User",
                                "kind": "LinkedField",
                                "name": "choiceUser",
                                "plural": false,
                                "selections": [
                                  (v5/*: any*/),
                                  (v13/*: any*/),
                                  (v6/*: any*/),
                                  (v23/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "type": "RelationshipCustomProfileField",
                            "abstractKey": null
                          },
                          (v23/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "viewerVisibleCustomProfileFields(first:30)"
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "CheckinRelationship",
                "kind": "LinkedField",
                "name": "viewerUserRelationship",
                "plural": false,
                "selections": [
                  (v20/*: any*/),
                  {
                    "alias": null,
                    "args": (v21/*: any*/),
                    "concreteType": "checkinRelationshipOneOnOneMeetingsConnection",
                    "kind": "LinkedField",
                    "name": "oneOnOneMeetings",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "checkinRelationshipOneOnOneMeetingsEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "OneOnOneMeeting",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v22/*: any*/),
                              (v5/*: any*/),
                              (v23/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": "oneOnOneMeetings(first:1)"
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "nextRecurringOneOnOneMeeting",
                    "plural": false,
                    "selections": [
                      (v16/*: any*/),
                      (v23/*: any*/),
                      (v22/*: any*/),
                      (v24/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "User",
                    "kind": "LinkedField",
                    "name": "report",
                    "plural": false,
                    "selections": (v30/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "User",
                    "kind": "LinkedField",
                    "name": "manager",
                    "plural": false,
                    "selections": (v30/*: any*/),
                    "storageKey": null
                  },
                  (v23/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v26/*: any*/),
                "concreteType": "UserVisibleFeedbackConnection",
                "kind": "LinkedField",
                "name": "viewerVisibleFeedback",
                "plural": false,
                "selections": [
                  (v27/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "UserVisibleFeedbackEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v16/*: any*/),
                          (v23/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "body",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "createdAt",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "CompanyValue",
                                "kind": "LinkedField",
                                "name": "companyValues",
                                "plural": true,
                                "selections": (v31/*: any*/),
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "User",
                                "kind": "LinkedField",
                                "name": "targets",
                                "plural": true,
                                "selections": (v32/*: any*/),
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "User",
                                "kind": "LinkedField",
                                "name": "author",
                                "plural": false,
                                "selections": [
                                  (v8/*: any*/),
                                  (v6/*: any*/),
                                  (v29/*: any*/),
                                  (v23/*: any*/)
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Competency",
                                "kind": "LinkedField",
                                "name": "competency",
                                "plural": false,
                                "selections": (v31/*: any*/),
                                "storageKey": null
                              }
                            ],
                            "type": "Feedback",
                            "abstractKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "viewerVisibleFeedback(first:20)"
              },
              {
                "alias": "activeGoals",
                "args": (v28/*: any*/),
                "concreteType": "userOwnedGoalsConnection",
                "kind": "LinkedField",
                "name": "ownedGoals",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "userOwnedGoalsEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Goal",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Goal",
                            "kind": "LinkedField",
                            "name": "childrenList",
                            "plural": true,
                            "selections": (v32/*: any*/),
                            "storageKey": null
                          },
                          (v5/*: any*/),
                          (v23/*: any*/),
                          (v6/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "private",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "state",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "status",
                            "storageKey": null
                          },
                          {
                            "alias": "amountType",
                            "args": null,
                            "kind": "ScalarField",
                            "name": "computedAmountType",
                            "storageKey": null
                          },
                          {
                            "alias": "goalAmount",
                            "args": null,
                            "kind": "ScalarField",
                            "name": "computedGoalAmount",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "progressAmount",
                            "storageKey": null
                          },
                          {
                            "alias": "startingAmount",
                            "args": null,
                            "kind": "ScalarField",
                            "name": "computedStartingAmount",
                            "storageKey": null
                          },
                          {
                            "alias": "type",
                            "args": null,
                            "kind": "ScalarField",
                            "name": "computedType",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "computedProgressAmount",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "ownedGoals(last:100,orderBy:\"Priority\",state:\"ACTIVE\")"
              },
              (v23/*: any*/)
            ],
            "storageKey": null
          },
          (v23/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "14f8f2427ac6dc1450d632df32ab9dca",
    "id": null,
    "metadata": {},
    "name": "DirectoryProfileQuery",
    "operationKind": "query",
    "text": "query DirectoryProfileQuery(\n  $userEntityId: String!\n) {\n  viewer {\n    features\n    user: findUser(userId: $userEntityId) {\n      viewerIsUser\n      startedAfterPercentage\n      entityId\n      name\n      title\n      avatarUrl\n      startDate\n      phoneNumber\n      timezone\n      realTimezone\n      email\n      department {\n        name\n        entityId\n        id\n      }\n      manager {\n        entityId\n        name\n        email\n        id\n      }\n      products {\n        feedback {\n          isEnabled\n        }\n      }\n      viewerVisibleCustomProfileFields(first: 30) {\n        edges {\n          node {\n            __typename\n            fieldName\n            displayedValue\n            privacyLevel\n            ... on RelationshipCustomProfileField {\n              choiceUser {\n                entityId\n                email\n                name\n                id\n              }\n            }\n            id\n          }\n        }\n      }\n      viewerUserRelationship {\n        isOneOnOneActive\n        oneOnOneMeetings(first: 1) {\n          edges {\n            node {\n              scheduledAt\n              entityId\n              id\n            }\n          }\n        }\n        nextRecurringOneOnOneMeeting {\n          __typename\n          id\n          scheduledAt\n          ... on OneOnOneMeeting {\n            entityId\n          }\n        }\n        report {\n          entityId\n          viewerIsUser\n          ...NextMeetingCard_user\n          id\n        }\n        manager {\n          entityId\n          viewerIsUser\n          ...NextMeetingCard_user\n          id\n        }\n        id\n      }\n      viewerVisibleFeedback(first: 20) {\n        pageInfo {\n          hasNextPage\n        }\n        edges {\n          node {\n            __typename\n            id\n            ...FeedbackCard_feedback\n          }\n        }\n      }\n      activeGoals: ownedGoals(state: ACTIVE, last: 100, orderBy: Priority) {\n        edges {\n          node {\n            ...GoalCard_goal\n            id\n          }\n        }\n      }\n      id\n    }\n    id\n  }\n}\n\nfragment FeedbackCard_feedback on Feedback {\n  body\n  createdAt\n  companyValues {\n    name\n    id\n  }\n  targets {\n    id\n  }\n  author {\n    avatarUrl\n    name\n    preferredName\n    ...UserChip_user\n    id\n  }\n  competency {\n    name\n    id\n  }\n}\n\nfragment GoalBadge_goal on Goal {\n  computedProgressAmount\n  entityId\n  id\n  state\n  status\n  type: computedType\n}\n\nfragment GoalCard_goal on Goal {\n  childrenList {\n    id\n  }\n  entityId\n  id\n  name\n  private\n  state\n  status\n  ...GoalProgress_goal\n  ...GoalBadge_goal\n}\n\nfragment GoalProgress_goal on Goal {\n  id\n  amountType: computedAmountType\n  goalAmount: computedGoalAmount\n  progressAmount\n  startingAmount: computedStartingAmount\n  type: computedType\n  computedProgressAmount\n}\n\nfragment NextMeetingCard_user on User {\n  id\n  ...UserChip_user\n}\n\nfragment UserChip_user on User {\n  preferredName\n  name\n  avatarUrl\n}\n"
  }
};
})();

(node as any).hash = "7ad921e7a992b7745c5449656eeb99d7";

export default node;
